import { motion } from "framer-motion";

const reasons = [
  {
    icon: "✅",
    title: "Works with any frontend",
    desc: "Just use our form endpoint in your HTML or JS-based site—no backend needed.",
  },
  {
    icon: "🔐",
    title: "Secure with API keys",
    desc: "Every request is verified by your unique API key, keeping spam and abuse out.",
  },
  {
    icon: "📥",
    title: "Receives emails directly",
    desc: "Get submissions sent straight to your inbox in real time.",
  },
  {
    icon: "🧩",
    title: "Easy to integrate",
    desc: "Start sending emails in under 5 minutes—zero config required.",
  },
];

export default function WhyMBMailer() {
  return (
    <section className="bg-black rounded py-16 px-4 sm:px-8 lg:px-16 mb-4">
      <h2 className="text-3xl font-bold text-center mb-12">
        Why use MBMailer?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {reasons.map((reason, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.2, duration: 0.6 }}
            className="bg-gray-100 p-6 rounded-2xl shadow-sm hover:shadow-md transition"
          >
            <div className="text-4xl mb-4">{reason.icon}</div>
            <h3 className="text-xl text-blue-500 font-semibold mb-2">
              {reason.title}
            </h3>
            <p className="text-orange-600">{reason.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
